import {initCreateStoreWizard} from './Wizard';

const initializedWizards = new WeakSet();

export const initializeCreateStoreWizards = root => {
    root.querySelectorAll('[data-controller="create-store-wizard"]').forEach(wizard => {
        if (initializedWizards.has(wizard)) {
            return;
        }

        initializedWizards.add(wizard);

        initCreateStoreWizard(wizard);
    });
};
